import { useCallback } from 'react';

import { useWebSocket } from 'api/hooks';

type JourneyReviewWebSocketOptions = {
  websocketId: string | null;
  isEnabled: boolean;
  onComplete: (status: 'success' | 'error') => void;
};

export const useJourneyReviewWebSocket = ({
  websocketId,
  isEnabled,
  onComplete,
}: JourneyReviewWebSocketOptions) => {
  const websocketPath = websocketId ? `journey-reviews/${websocketId}/` : '';

  const handleMessage = useCallback(
    (event: MessageEvent<string>) => {
      if (!event?.data) return;
      const envelope = JSON.parse(event.data);
      if (!envelope || envelope.type !== 'update' || !envelope.content) return;
      const status = envelope.content.status;
      if (status === 'success' || status === 'error') {
        onComplete(status);
      }
    },
    [onComplete]
  );

  useWebSocket<string>(websocketPath, handleMessage, {
    enabled: Boolean(websocketPath && isEnabled),
    throttleTime: 0,
  });
};
